import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ReactHtmlParser from 'react-html-parser';
import { colors } from '../../../colors';
import { alpha } from '@mui/material/styles';

interface Props {
  highlights: any;
}

function translateField(value: string): string {
  switch (value) {
    case 'name': return 'Navn';
    case 'dateOfBirth': return 'Fødselsdato';
    case 'debtorIds': return 'Kundenummer';
    case 'nationalIdentityNumber': return 'Fødselsnummer';
    case 'organizationNumber': return 'Organisasjonsnummer';
    case 'phoneNumbers': return 'Telefonnummer';
    case 'invoiceNumbers': return 'Fakturanummer';
    case 'caseNumbers': return 'Saksnummer';
    case 'orderNumbers': return 'Ordrenummer';
    case 'kidNumbers': return 'KID';
    default:
      return value;
  }
}

export default function DebtorSearchResultReason(props: Props) {
  return (
    <Box sx={{
      marginTop: '10px',
      display: 'flex',
      alignContent: 'center'
    }}>
      <Typography sx={{
        paddingTop: '5px',
        fontWeight: 'bold',
        marginRight: '6px',
        fontSize: '0.875rem'
      }}>
        Treff på:
      </Typography>
      {props.highlights && Object.keys(props.highlights).map((item, i) =>
        <Typography sx={{
          borderWidth: '1px',
          borderStyle: 'dashed',
          borderColor: 'primary.dark',
          borderRadius: '4px',
          padding: '4px 6px',
          fontSize: '0.875rem',
          '& em': {
            backgroundColor: alpha(colors.secondary.lemon, 0.4),
            padding: '2px 4px 2px 4px',
            fontStyle: 'normal',
          },
        }} key={i}>
          {translateField(item)}:{' '}{ReactHtmlParser(props.highlights[item])}
        </Typography>
      )}
    </Box>
  )
};
